<template>
  <ul class="fa-ul">
    <li v-for="(step, index) in history" :key="index" v-if="decisions[step.to].title_type == 'obligation'">
      <i class="fa fa-li fa-exclamation-circle"></i> <span v-for="(item, index2) in decisions[step.to].title" v-if="'text' in item" :key="index2">{{ item.text }}</span>
      <ul>
        <li v-for="(chunk, index2) in decisions[step.to].text" :key="index2" :parts="chunk.parts" :type="chunk.type" v-if="chunk.type == 'recommendation'">
          <RichText :parts="chunk.parts" :type="chunk.type" />
        </li>

      </ul>
    </li>
  </ul>
</template>

<script>
import RichText from './RichText'
export default {
  name: 'Obligations',
  components: {RichText},
  props: ['history', 'decisions']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Obligations.vue